<template>
    <div class="code-inputer" :class="{error: codeError}">
        <el-form class="codelab-form" @submit.native.prevent>
            <h3>{{$t("quick_connect.random_code")}}</h3>
            <el-form-item>
                <input
                v-for="(code,index) in verCode.slice(0,6)"
                :ref="'input' + index"
                :key="index"
                type="text"
                maxlength="1"
                :tabindex="index + 1"
                class="number-input"
                v-model="verCode[index]"
                @keydown="onKeydown($event, index)"
                @keyup="onKeyup($event, index)"
                @focus="onFocus"
                />
            </el-form-item>
            <h3>{{$t("quick_connect.serial_number")}}</h3>
            <el-form-item>
                <input
                v-for="(code,index) in verCode.slice(6)"
                :ref="'input' + (index + 6)"
                :key="index + 6"
                type="text"
                maxlength="1"
                :tabindex="index + 7"
                class="number-input"
                v-model="verCode[index+6]"
                @keydown="onKeydown($event, index + 6)"
                @keyup="onKeyup($event, index + 6)"
                @focus="onFocus"
                />
            </el-form-item>
        </el-form>
        <p class="error-tip error" v-if="codeError">
            {{$t("quick_connect.message_connect_failed")}}
        </p>
    </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
    name: "code-inputer",
    data () {
        return {
            verCode: (new Array(12)).fill(''),
            codeValidate: false,
            codeError: false
        }
    },
    computed: {
        ...mapState("quickConnection", [ "socketCode" ])
    },
    watch: {
        verCode () {
            this.validateCode()
            if(this.codeValidate){
                this.$emit("change", this.getConnectData());
            } else {
                this.$emit("change", null);
            }
        },
        socketCode(code){
            console.log("socket code:", code)
            if (code === 4002) {
                this.codeError = true;
            } else {
                this.codeError = false;
            }
        }
    },
    created(){
        let lastSerialNumber = window.localStorage.getItem("robotLastSixCode");
        if(lastSerialNumber && lastSerialNumber.length === 6){
            lastSerialNumber = lastSerialNumber.split("");
            this.verCode.splice(6, 6 )
            this.verCode = [...this.verCode.slice(0, 6), ...lastSerialNumber];
        }
    },
    mounted(){
        this.$nextTick(() => {
            if (this.$refs.input0 && this.$refs.input0[0]) {
                this.$refs.input0[0].focus()
            }
        })
    },
    methods: {
        storeSerialNumber(number){
            window.localStorage.setItem("robot_serial_number", number);
        },
        emptyRandomCode () {
            let randomCode = (new Array(6)).fill('')
            this.verCode = [...randomCode, ...(this.verCode.slice(6))]
        },
        onKeydown (event, index) {
            let keyCode = event.keyCode
            if (keyCode === 8) {
                if (this.verCode[index] !== '') {
                    this.$nextTick(() => {
                        this.verCode[index] = ''
                    })
                }
            }
            if (keyCode === 9) {
                this.nextInput(index)
                event.returnValue = false
            }
        },
        onKeyup (event, index) {
            let keyCode = event.keyCode
            if (this.codeError) {
                this.codeError = false
            }
            if (keyCode === 8) {
                this.$nextTick(() => {
                    this.prevInput(index)
                })
            } else if (keyCode === 13) {
                this.$emit("confirm", this.getConnectData());
            } else {
                this.nextInput(index)
            }
        },
        validateCode () {
            let code = this.verCode
            if (code.length !== 12) {
                this.codeValidate = false
                return
            }
            this.codeValidate = code.every(item => /^[\w]$/.test(item))
        },
        prevInput (index) {
            index--
            if (this.verCode[index] !== undefined && this.$refs['input' + index] && this.$refs['input' + index][0]) {
                this.focusInput(this.$refs['input' + index][0])
            }
        },
        nextInput (index) {
            if (this.verCode[index] === '' || this.verCode[index] === undefined) {
                return
            }
            index++
            if (this.verCode[index] !== undefined && this.$refs['input' + index] && this.$refs['input' + index][0]) {
                this.focusInput(this.$refs['input' + index][0])
            }
        },
        focusInput (input) {
            if (!input) {
                return
            }
            input.focus && input.focus()
        },
        onFocus (event) {
            let input = event.target
            input.select && input.select()
        },
        getConnectData () {
            let randomCode = this.verCode.slice(0, 6).join('')
            let serialNumber = this.verCode.slice(6).join('')
            return {
                randomCode,
                serialNumber
            }
        }
    }
}
</script>
<style lang="scss">
.code-inputer{
    position: relative;
    padding-bottom: 24px;
    color: #0ed3ff;
    h3{
        color: #ffffff;
        font-size: 14px;
        font-weight: normal;
        padding: 12px 0;
    }
    .el-form-item{
        margin-bottom: 8px;
    }
    .el-form-item__content{
        display: flex;
        justify-content: flex-start;
        flex-wrap: nowrap;
        .number-input{
            
            padding: 0;
            width: 30px;
            height: 36px;
            text-align: center;
            font-size: 21px;
            font-weight: bold;
            color: inherit;
            background: #333333;
            border: 2px solid transparent;
            border-radius: 8px;
            outline: none;
            margin-right: 5px;
            &:focus{
                border-color: #a8a8ac;
            }
        }
    }
    .error-tip{
        position: absolute;
        bottom: 0px;
        left: 0px;
        font-size: 12px;
        line-height: 24px;
    }
    &.error{
        color: #fd5c53;
    }
}
</style>